/**
 * Seed values shared by the factory and the migration.
 *
 * The migration needs them because the editor used to merge a freshly seeded
 * column's `data` over the persisted one before validating — a step that only
 * made sense while both shapes were the same. In v0 the migration is the single
 * place where a missing field acquires its default, so the two must agree.
 */
export const DEFAULT_TRANSPARENT_COLOR = 'rgba(255, 255, 255, 0)';
export const DEFAULT_BORDER_COLOR = '#000';
export const DEFAULT_OVERLAY_COLOR = '#ffffff';
export const DEFAULT_OVERLAY_OPACITY = 0.5;
/** `EFilerOverlay.BLURRY` / `EScrollEffect.FIXED` — CSS literals on the host enums. */
export const DEFAULT_FILTER_OVERLAY = 'blur(3px)';
export const DEFAULT_SCROLL_EFFECT = 'fixed';
